export const REPORTS_BASE_PATH = '/reports/dashboard';
